import API_BASE_URL from '../config';

export default function profileImageUrl(value) {
  if (!value) return '';
  const path = value.replace(/\\/g, '/');
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE_URL}${path.startsWith('/') ? path : `/uploads/${path}`}`;
}
